import './TableWithSearch.scss';
import TableWithSearch from "./TableWithSearch";

export default TableWithSearch;